import { render, staticRenderFns } from "./case-division-import.vue?vue&type=template&id=88abcf96&scoped=true"
import script from "./case-division-import.vue?vue&type=script&lang=ts"
export * from "./case-division-import.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88abcf96",
  null
  
)

export default component.exports